import { render, staticRenderFns } from "./reconsent-modal.vue?vue&type=template&id=43267ff3&scoped=true&"
import script from "./reconsent-modal.vue?vue&type=script&lang=js&"
export * from "./reconsent-modal.vue?vue&type=script&lang=js&"
import style0 from "./reconsent-modal.vue?vue&type=style&index=0&id=43267ff3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43267ff3",
  null
  
)

export default component.exports